<div class="card">
    <div class="card-header" (click)="isCollapsed = !isCollapsed" style="cursor: pointer;">
        <h3 class="mb-0 d-flex align-items-center">
            <button class="btn btn-link d-flex align-items-center text-decoration-none" type="button"
                style="color: black;">
                <i class="bi bi-chevron-right" [style.transform]="isCollapsed ? 'rotate(0deg)' : 'rotate(90deg)'"
                    style="transition: transform 0.2s;"></i>
                <span class="ms-2">
                    <h3>Legacy Table Data</h3>
                </span>
            </button>
        </h3>
    </div>

    <div [ngbCollapse]="isCollapsed">
        <div class="card-body">
            <table class="table table-striped ">
                <thead>
                    <th scope="col">{{'Label' | i18n}}</th>
                    <th scope="col">{{'Value' | i18n}}</th>
                    <th scope="col" class="hide-on-mobile">{{'Score' | i18n}}</th>
                </thead>
                <tbody>
                    <tr scope="row" *ngFor="let item of tableData; let i = index" (mouseover)="receiptItemOver(item)"
                        [class.trChosen]="item.chosen == true">


                        <td><input type="text" [(ngModel)]="item.label.word.text" [size]="item.label.word.text.length"
                                class="editable" (focusout)="itemFocusout()"></td>

                        <td class="valueColumn"><input type="text" [(ngModel)]="item.value.word.text" class="editable"
                                (focusout)="itemFocusout()" [style.color]="item.color"></td>

                        <td class="hide-on-mobile"> % {{printScore(item)}}</td>
                    </tr>
                </tbody>
            </table>
            <div (click)="downloadImg()">
                {{uid}}
            </div>
        </div>
    </div>
</div>